import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { HelmetProvider } from "react-helmet-async";
import Home from "./pages/Home";
import ThankYou from "./pages/ThankYou";
import AdminDashboard from "./pages/AdminDashboard";
import Quiz from "./pages/Quiz";
import DirectMax from "./pages/DirectMax";
import { MensHormoneSupport, HairHealth, EnergyMetabolism } from "./pages/ComingSoon";
import Calculator from "./pages/Calculator";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import StartHere from "./pages/StartHere";
import CostCalculator from "./pages/CostCalculator";
import MedicationMatch from "./pages/MedicationMatch";
import MealPlan from "./pages/MealPlan";
import StrengthPlan from "./pages/StrengthPlan";
import BottomNav from "./components/BottomNav";
import { initGA, trackPageView } from "./utils/analytics";

// Initialize GA4 on app load
initGA();

// Page view tracker component
function PageViewTracker() {
  const location = useLocation();
  
  useEffect(() => {
    // Track page view on route change
    trackPageView(location.pathname, document.title);
    // trackPageView is a stable function from analytics.js, doesn't need to be a dependency
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);
  
  return null;
}

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <PageViewTracker />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/calculator" element={<Calculator />} />
            <Route path="/quiz" element={<Navigate to="/calculator" replace />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/start-here" element={<StartHere />} />
            <Route path="/cost-calculator" element={<CostCalculator />} />
            <Route path="/medication-match" element={<MedicationMatch />} />
            <Route path="/meal-plan" element={<MealPlan />} />
            <Route path="/strength-plan" element={<StrengthPlan />} />
            <Route path="/directmax" element={<DirectMax />} />
            <Route path="/mens-hormone-support" element={<MensHormoneSupport />} />
            <Route path="/hair-health" element={<HairHealth />} />
            <Route path="/energy-metabolism" element={<EnergyMetabolism />} />
            <Route path="/thank-you" element={<ThankYou />} />
            <Route path="/admin" element={<AdminDashboard />} />
          </Routes>
          <BottomNav />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
